import * as React from 'react'
import {type ConsoleAgentT} from '../helpers/auth-helpers'
import {initializePendo} from '../helpers/pendo-helpers'

type Props = {
  children: React.ReactNode
  agent: ConsoleAgentT
}

export function PendoWrapper({children, agent}: Props): React.ReactElement {
  React.useEffect(() => {
    initializePendo(agent)
  }, [agent])

  return <>{children}</>
}
